import React from 'react';

/**
 * LandingScreen Component
 * First screen users see - introduces the quiz and CTA to start
 * 
 * @param {function} onStart - Callback when user clicks start button
 */
export default function LandingScreen({ onStart }) {
  return (
    <div className="min-h-screen relative z-10 flex items-center justify-center p-3 sm:p-4">
      <div className="max-w-lg md:max-w-xl lg:max-w-2xl w-full">
        {/* Logo */}
        <div className="text-center mb-4 sm:mb-6 md:mb-8">
          <img 
            src="/logos/thryv_consulting_logo_02tw_web.png" 
            alt="Thryv Consulting" 
            className="h-10 sm:h-12 mx-auto mb-2"
          />
        </div>
        
        {/* Main Content Card */}
        <div className="card text-center">
          {/* Hero Image */}
          <div className="mb-4 sm:mb-6">
            <img 
              src="/thryv_pipeline_leak_quiz_01.png" 
              alt="Pipeline Revenue Leak Quiz" 
              className="w-full max-w-md mx-auto rounded-xl"
            />
          </div>
          
          {/* Headline */}
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-3 sm:mb-4 leading-tight">
            How Much Pipeline Revenue<br />Are You Losing?
          </h1>
          
          {/* Subheadline */}
          <p className="text-base sm:text-lg md:text-xl text-gray-300 mb-4 sm:mb-6 md:mb-8">
            Most founders are leaving <span className="text-thryv-green font-semibold">$50K-$500K</span> on the table 
            annually due to fixable pipeline gaps.
          </p>
          
          {/* Value Props */}
          <div className="text-left max-w-md mx-auto mb-4 sm:mb-6 md:mb-8 space-y-2 sm:space-y-3">
            <p className="text-base sm:text-lg text-gray-200 font-medium mb-2 sm:mb-4">
              This 2-minute assessment will show you:
            </p>
            <div className="space-y-1.5 sm:space-y-2">
              <div className="flex items-start">
                <span className="text-thryv-green mr-2 sm:mr-3 text-lg sm:text-xl">•</span>
                <span className="text-sm sm:text-base text-gray-300">Where leads are falling through</span>
              </div>
              <div className="flex items-start">
                <span className="text-thryv-green mr-2 sm:mr-3 text-lg sm:text-xl">•</span>
                <span className="text-sm sm:text-base text-gray-300">Which funnel stage needs attention</span>
              </div>
              <div className="flex items-start">
                <span className="text-thryv-green mr-2 sm:mr-3 text-lg sm:text-xl">•</span>
                <span className="text-sm sm:text-base text-gray-300">Your estimated annual revenue leak</span>
              </div>
            </div>
          </div>
          
          {/* CTA Button */}
          <button 
            onClick={onStart}
            className="btn-primary text-base sm:text-lg w-full md:w-auto md:px-12"
          >
            START ASSESSMENT →
          </button>
          
          {/* Trust Indicator */}
          <p className="text-xs sm:text-sm text-gray-400 mt-4 sm:mt-6">
            No email required to start. Results are instant.
          </p>
        </div>
      </div>
    </div>
  );
}

